import React, { useCallback } from 'react';
import Input from '../../wui-input/src';
import { SearchProps } from './iTransfer';

const defaultProps = {
    placeholder: '',
    fieldid: ''
};

const Search: React.FC<SearchProps> = (props) => {
    const {
        placeholder = '',
        value,
        prefixCls,
        fieldid,
        disabled,
        onChange,
    } = props;
    const fieldidProp = fieldid ? { fieldid } : {};

    const handleChange = useCallback((e: string) => {
        onChange && onChange(e);
    }, [onChange]);

    return (
        <div>
            <Input
                size="sm"
                placeholder={placeholder}
                className={prefixCls}
                value={value}
                type='search'
                showClose
                disabled={disabled}
                onChange={handleChange}
                {...fieldidProp}
            />
        </div>
    );
};

Search.defaultProps = defaultProps;
export default Search;
